import React, { useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useAuth } from '../contexts/AuthContext';
import { canAccessAdmin, canAccessAuditLogs, canAccessInternalPages } from '../utils/accessControl';

const InternalNavbar = () => {
	const navigate = useNavigate();
	const menuRef = useRef(null);
	const { accessContext, logout } = useAuth();
	const canManageUsers = canAccessAdmin(accessContext);
	const canSeeAuditLogs = canAccessAuditLogs(accessContext);
	const canAccessInternal = canAccessInternalPages(accessContext);

	const logoutUser = async () => {
		await logout();
		navigate('/login');
	};

	const items = useMemo(() => {
		const next = [];

		if (canAccessInternal) {
			next.unshift(
				{
					label: 'Resources',
					icon: 'pi pi-folder',
					command: () => navigate('/resources'),
				},
				{
					label: 'Downloads',
					icon: 'pi pi-download',
					command: () => navigate('/downloads'),
				},
				{
					label: 'Members',
					icon: 'pi pi-users',
					command: () => navigate('/members'),
				}
			);
		}

		if (canSeeAuditLogs) {
			next.push({
				label: 'Audit Logs',
				icon: 'pi pi-history',
				command: () => navigate('/auditlogs'),
			});
		}

		if (canManageUsers) {
			next.push(
				{
					label: 'Users',
					icon: 'pi pi-users',
					command: () => navigate('/admin/users'),
				},
				{
					label: 'Manage Resources',
					icon: 'pi pi-book',
					command: () => navigate('/admin/resources'),
				},
				{
					label: 'Catalog',
					icon: 'pi pi-list',
					command: () => navigate('/admin/catalog'),
				},
				{
					label: 'Active Access Branding Portal',
					icon: 'pi pi-palette',
					command: () => navigate('/admin/active-access-branding'),
				}
			);
		}

		next.push(
			{ separator: true },
			{
				label: 'Logout',
				icon: 'pi pi-sign-out',
				command: logoutUser,
			}
		);

		return next;
	}, [navigate, logoutUser, canManageUsers, canSeeAuditLogs, canAccessInternal]);

	return (
		<div className="panel app-navbar" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
			<div className="flex align-items-center justify-content-between">
				<Button
					label="Smart Tile"
					className="p-button-text"
					aria-label="Smart Tile home"
					onClick={() => navigate('/')}
				/>
				<div className="flex align-items-center">
					<Button
						icon="pi pi-bars"
						className="p-button-text"
						aria-label="Internal menu"
						onClick={(e) => menuRef.current && menuRef.current.toggle(e)}
					/>
					<Menu model={items} popup ref={menuRef} />
				</div>
			</div>
		</div>
	);
};

export default InternalNavbar;
